import { FC, JSX } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { twMerge } from 'tailwind-merge';

import { StylesConfig } from '@player/content';

interface IPositionSelectorProps {}

type LogoPosition = 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';

const PositionSelector: FC<IPositionSelectorProps> = (): JSX.Element => {
  const { control } = useFormContext<{ config: StylesConfig }>();

  const positions: Array<LogoPosition | null> = [
    'top-left',
    null,
    'top-right',
    null,
    null,
    null,
    'bottom-left',
    null,
    'bottom-right',
  ];

  return (
    <Controller
      control={control}
      name="config.logo.position"
      render={({ field: { value = 'bottom-left', onChange } }) => (
        <div
          className="grid h-32 w-3/6 rounded-lg bg-[#f6f8ff] p-2"
          style={{
            gridGap: '8px',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gridTemplateRows: 'repeat(3, 1fr)',
          }}
        >
          {positions.map((position, index) => (
            <div
              key={index}
              className={twMerge(
                'group flex cursor-pointer items-center justify-center',
                !position && 'pointer-events-none'
              )}
              onClick={() => position && onChange(position)}
            >
              {value === position ? (
                <div className="flex w-5 flex-col gap-0.5">
                  <div className="h-[3px] w-1/2 rounded-lg bg-blue" />
                  <div className="h-[3px] w-full rounded-lg bg-blue" />
                  <div className="h-[3px] w-1/2 rounded-lg bg-blue" />
                </div>
              ) : (
                <div
                  className={twMerge(
                    'pointer-events-none h-1 w-1 rounded-full group-hover:bg-[#1d1e2f]/[.5]',
                    position ? 'bg-[#1d1e2f]/[.16]' : 'bg-[#1d1e2f]/[.04]'
                  )}
                />
              )}
            </div>
          ))}
        </div>
      )}
    />
  );
};

export default PositionSelector;
